export const USER_ERROR_CODES = {
    CUSTOMER_GET_FAILURE: "CustomerGetFailure",
    HEADER_OR_POST_DATA_INVALID: "HeaderOrPostDataInvalid",
} as const;
